"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKVisitor = exports.BaseVisitor = void 0;
const model_1 = require("./model");
class BaseVisitor {
    visit_agg(param) {
        this.visit_node(param);
    }
    visit_error(param) {
        this.visit_node(param);
    }
    visit_attr(param) {
        this.visit_node(param);
    }
    visit_asterisk(param) {
        this.visit_node(param);
    }
    visit_case(param) {
        this.visit_node(param);
    }
    visit_cast(param) {
        this.visit_node(param);
    }
    visit_const(param) {
        this.visit_node(param);
    }
    visit_copy(param) {
        this.visit_node(param);
    }
    visit_create(param) {
        this.visit_node(param);
    }
    visit_create_stage(param) {
        this.visit_node(param);
    }
    visit_create_view(param) {
        this.visit_node(param);
    }
    visit_delete(param) {
        this.visit_node(param);
    }
    visit_ds(param) {
        this.visit_node(param);
    }
    visit_else(param) {
        this.visit_node(param);
    }
    visit_expr(param) {
        this.visit_node(param);
    }
    visit_filter(param) {
        this.visit_node(param);
    }
    visit_frame(param) {
        this.visit_node(param);
    }
    visit_func(param) {
        this.visit_node(param);
    }
    visit_in(param) {
        this.visit_node(param);
    }
    visit_insert(param) {
        this.visit_node(param);
    }
    visit_into(param) {
        this.visit_node(param);
    }
    visit_join(param) {
        this.visit_node(param);
    }
    visit_matchrecognize(param) {
        this.visit_node(param);
    }
    visit_merge(param) {
        this.visit_node(param);
    }
    visit_node(obj) {
        for (const objKey in obj) {
            if (obj[objKey] === undefined) {
                continue;
            }
            if (typeof obj[objKey] != "object") {
                continue;
            }
            if (obj[objKey] == null) {
                continue;
            }
            if (Array.isArray(obj[objKey])) {
                for (const objElementElement of obj[objKey]) {
                    if (objElementElement instanceof model_1.TreeNode) {
                        objElementElement.accept(this);
                    }
                }
            }
            else {
                if (obj[objKey] instanceof model_1.TreeNode) {
                    obj[objKey].accept(this);
                }
            }
        }
    }
    visit_op(param) {
        this.visit_node(param);
    }
    visit_out(param) {
        this.visit_node(param);
    }
    visit_page(param) {
        this.visit_node(param);
    }
    visit_parseql(param) {
        this.visit_node(param);
    }
    visit_sort(param) {
        this.visit_node(param);
    }
    visit_statement(param) {
        this.visit_node(param);
    }
    visit_structref(param) {
        this.visit_node(param);
    }
    visit_tablefunc(param) {
        this.visit_node(param);
    }
    visit_tablesample(param) {
        this.visit_node(param);
    }
    visit_then(param) {
        this.visit_node(param);
    }
    visit_update(param) {
        this.visit_node(param);
    }
    visit_vfilter(param) {
        this.visit_node(param);
    }
    visit_wfunc(param) {
        this.visit_node(param);
    }
    visit_when(param) {
        this.visit_node(param);
    }
}
exports.BaseVisitor = BaseVisitor;
class SDKVisitor extends BaseVisitor {
    constructor() {
        super(...arguments);
        this.ds_list = new Set();
        this.table_list = new Set();
        this.column_list = new Set();
    }
    visit_ds(param) {
        super.visit_ds(param);
        this.ds_list.add(param);
        if (param.type == "table") {
            this.table_list.add(param);
        }
    }
    visit_attr(param) {
        super.visit_attr(param);
        this.column_list.add(param);
    }
}
exports.SDKVisitor = SDKVisitor;
